
import caseList from './list/caseListDetail'
import Confirm from 'vux/src/components/confirm/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'

import Vue from 'vue'
import Scroll from '../../base/scroll/scroll'
import {eventBus} from '../../../eventbus'
export default {
components: {
caseList,
Scroll,
Confirm,
Alert,
XDialog
},
data () {
return {
$vue: '',
toLeft: true,
toBottom: false,
caseListOption: [],
searchCondition: new Map(),

openIndex: -1,
listData: [],
clickedCaseId: '',
scrollbar: true,
scrollbarFade: true,
pullDownRefresh: true,
pullDownRefreshThreshold: 90,
pullDownRefreshStop: 40,
pullUpLoad: true,
pullUpLoadThreshold: 0,
startY: 0,
scrollToX: 0,
scrollToY: -200,
scrollToTime: 700,
scrollToEasing: 'bounce',
showInvalid: false,
showError: false,
refreshResult: ''
}
},
computed: {

scrollbarObj: function () {
return this.scrollbar ? {fade: this.scrollbarFade} : false
},

pullDownRefreshObj: function () {
return this.pullDownRefresh ? {
threshold: parseInt(this.pullDownRefreshThreshold),
stop: parseInt(this.pullDownRefreshStop)
} : false
},

pullUpLoadObj: function () {
return this.pullUpLoad ? {
threshold: parseInt(this.pullUpLoadThreshold),
txt: {more: this.pullUpLoadMoreTxt, noMore: this.pullUpLoadNoMoreTxt}
} : false
}
},
methods: {

async initDzdCaseList () {

this.caseListOption = []



let dczOption = []
dczOption.url = this.$vue.getData('FIRST_DIAGNOSE_LIST_URL')
dczOption.listName = '初诊'
dczOption.caseListType = 'cz'

let dfzOption = []
dfzOption.url = this.$vue.getData('FURTHER_CONSULTATION_LIST_URL')
dfzOption.listName = '复诊'
dfzOption.caseListType = 'fz'

let dhzOption = []
dhzOption.url = this.$vue.getData('CONSULTATION_LIST_URL')
dhzOption.listName = '会诊'
dhzOption.caseListType = 'hz'

this.caseListOption.push(dczOption)
this.caseListOption.push(dfzOption)
this.caseListOption.push(dhzOption)
},

caseEvent (prop) {
this.clickedCaseId = prop.caseId
switch (prop.event) {
case 'startCz': // 开始初诊
this.startCz()
break
case 'startFz': // 开始复诊
this.startFz()
break
case 'startHz': // 开始会诊
this.startHz()
break
case 'checkCzReport': // 查看初诊
this.checkCzReport()
break
case 'checkFzReport': // 查看复诊
this.checkFzReport()
break
case 'checkHzReport': // 查看会诊
this.checkHzReport()
break
case 'checkDiagnoseReport': // 诊断结果
this.checkDiagnoseReport()
break
case 'invalidCase': // 诊断结果
this.showInvalidConfirm()
break
case 'startMz': // 诊断结果
this.startMz()
break
}
},

axiosPackage (url) {
let params = new URLSearchParams()
params.append('CASE_ID', this.clickedCaseId.toString())
return this.$http.post(url, params)
},

showInvalidConfirm () {
this.showInvalid = true
},

async invalidCase () {
let suc = await this.axiosPackage(this.$vue.getData('INVALID_URL'))
if (suc.data.result === 'success') {

this.$refs.cz[0].refreshList()
}
},

async startCz () {
let suc = await this.axiosPackage(this.$vue.getData('STARTCZ_URL'))
if (suc.data.result === '1') {

this.$router.push({ path: '/diagnosis/0/' + suc.data.data.CASE_ID })
} else {
this.showError = true
}
},

async startFz () {
let suc = await this.axiosPackage(this.$vue.getData('STARTFZ_URL'))
if (suc.data.result === '1') {

this.$router.push({ path: '/diagnosis/1/' + suc.data.data.CASE_ID })
} else {
this.showError = true
}
},

async startHz () {
let suc = await this.axiosPackage(this.$vue.getData('STARTHZ_URL'))
if (suc.data.result === '1') {

this.$router.push({ path: '/diagnosis/2/' + suc.data.data.CASE_ID })
} else {
this.showError = true
}
},

async checkCzReport () {

let params = new URLSearchParams()
params.append('CASE_ID', this.clickedCaseId)
params.append('REPORT_CLASS', '0')
let suc = await this.$http.post(this.$vue.getData('CASE_REPORT_LIST_URL'), params)
if (suc.data.result === '1') {

this.reportDetailInfo(suc.data.data[0])
}
},

async checkFzReport () {

let params = new URLSearchParams()
params.append('CASE_ID', this.clickedCaseId)
params.append('IS_FINAL', '1')
let suc = await this.$http.post(this.$vue.getData('CASE_REPORT_LIST_URL'), params)
if (suc.data.result === '1') {

this.reportDetailInfo(suc.data.data[0])
}
},

async checkHzReport () {

let params = new URLSearchParams()
params.append('CASE_ID', this.clickedCaseId)
params.append('REPORT_CLASS', '2')
let suc = await this.$http.post(this.$vue.getData('CASE_REPORT_LIST_URL'), params)
if (suc.data.result === '1') {

this.reportDetailInfo(suc.data.data[0])
}
},

async reportDetailInfo (item) {

eventBus.$emit('showLoading', true)
let params = new URLSearchParams()
params.append('CASE_ID', this.clickedCaseId)
params.append('REPORT_CLASS', item.REPORT_CLASS)
params.append('REPORT_ID', item.ID)
let suc = await this.$http.post(this.$vue.getData('REPORT_DETAIL_URL'), params)
if (suc.data.result === '1') {

this.$router.push({ name: 'reportdetail', params: {data: suc.data.data} })
} else {

eventBus.$emit('showLoading', false)
this.showError = true
}
},

getRefreshResult (prop) {
this.refreshResult = prop.result
},

onPullingDown () {

this.$refs.cz[0].refreshList()
this.$refs.fz[0].refreshList()
this.$refs.hz[0].refreshList()
setTimeout(() => {

this.$refs.scroll.forceUpdate()
}, 2000)
},

onPullingUp () {

setTimeout(() => {

this.$refs.scroll.forceUpdate()
}, 1500)
},
scrollToCaseList () {

setTimeout(this.scrollTo, 200)
},
scrollTo () {

let listHeight = document.querySelector('.conterUl').offsetHeight
this.$refs.scroll.scrollTo(-listHeight + 676)
},
updateScrollbar (val) {
this.scrollbar = val
},
updateScrollbarFade (val) {
this.scrollbarFade = val
},
updatePullDownRefresh (val) {
this.pullDownRefresh = val
},
updatePullDownRefreshThreshold (val) {
this.pullDownRefreshThreshold = val
},
updatePullDownRefreshStop (val) {
this.pullDownRefreshStop = val
},
updatePullUpLoad (val) {
this.pullUpLoad = val
},
updatePullUpLoadThreshold (val) {
this.pullUpLoadThreshold = val
},
updatePullUpLoadMoreTxt (val) {
this.pullUpLoadMoreTxt = val
},
updatePullUpLoadNoMoreTxt (val) {
this.pullUpLoadNoMoreTxt = val
},
updateStartY (val) {
this.startY = val
},
updateScrollToX (val) {
this.scrollToX = val
},
updateScrollToY (val) {
this.scrollToY = val
},
updateScrollToTime (val) {
this.scrollToTime = val
},
updateScrollToEasing (val) {
this.scrollToEasing = val
},
rebuildScroll () {
Vue.nextTick(() => {
this.$refs.scroll.destroy()
this.$refs.scroll.initScroll()
})
}
},
beforeMount () {

this.$vue = this

this.searchCondition = this.$route.params.searchCondition

this.initDzdCaseList()
},
beforeRouteEnter (to, from, next) {
next(vm => {

if (from.name === 'diagnosis' || from.name === 'reportdetail') {

let listType = localStorage.getItem('listType')

eval('vm.$refs.' + listType + '[0].openListAndSetPage()')
}
})
}
}



// WEBPACK FOOTER //
// ./src/components/doctor/caselist/dzdCaseList.vue